import React from 'react';
import { Empty, Typography } from 'antd';
import PaAgentModule from '../../saaspro/PaAgentModule';

const { Text } = Typography;

function UnsupportedModule({ moduleKey }) {
  return (
    <Empty
      description={(
        <>
          <Text strong>Module not supported in this app version</Text>
          <div style={{ color: 'rgba(0,0,0,0.55)', marginTop: 8 }}>
            Backend module <code>{moduleKey}</code> has no renderer in care-admin yet.
          </div>
        </>
      )}
    />
  );
}

/** Admin dynamic modules keyed by `admin_modules[].key` from partner detail API. */
export const ADMIN_MODULE_REGISTRY = {
  'pa-agent': PaAgentModule,
};

export function renderAdminModule(moduleKey, props) {
  const Component = ADMIN_MODULE_REGISTRY[moduleKey];
  if (!Component) {
    return <UnsupportedModule moduleKey={moduleKey} />;
  }
  return <Component {...props} />;
}
